import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { take } from 'rxjs/operators';
import { ModalService } from '@app/@core/modal/modal.service';
import { SpinnerService } from '../spinner/spinner.service';
import { CustomDialogComponent } from '../modal/customDialog/customDialog.component';
import { UserService } from '@app/services/user.service';
import { EmailTemplate } from '@app/interface/emailTemplate';
import { EmailTemplatesService } from '@app/services';
@Component({
  selector: 'app-email-template-table',
  templateUrl: './email-templates.component.html',
  styleUrls: [],
})
export class EmailTemplatesComponent implements OnChanges {
  @Input() isLoading = false;
  @Input() message: string;
  @Input() dataTable: EmailTemplate[];
  @Input() dataColumn: string;
  first: number = 0;
  rows: number = 5;
  values = '';
  dialogRef: any;

  constructor(
    private modalService: ModalService,
    private messageService: MessageService,
    private spinnerService: SpinnerService,
    public userService: UserService,
    private emailTemplatesService: EmailTemplatesService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.dataTable && changes.dataColumn) {
      this.dataTable = changes.dataTable.currentValue;
      this.dataColumn = changes.dataColumn.currentValue;
    }
  }

  public getIndex(arr: any, cognitive: any) {
    let index = arr.map((item: any) => item.id).indexOf(cognitive['id']);
    return index;
  }

  public isLastPage(): boolean {
    return this.dataTable ? this.first === this.dataTable.length - this.rows : true;
  }

  public isFirstPage(): boolean {
    return this.dataTable ? this.first === 0 : true;
  }

  public deleteEmailTemplate(emailTemplate: any) {
    this.modalService
      .confirm('Are you sure that you want to remove ' + emailTemplate['templateName'])
      .pipe(take(1))
      .subscribe((confirmed: any) => {
        if (confirmed) {
          this.spinnerService.show();
          this.removeTemplate(emailTemplate);
        }
      });
  }

  public removeTemplate(emailTemplate: any): void {
    this.emailTemplatesService.deleteEmailTemplate(emailTemplate.uuid).then(() => {
      this.spinnerService.hide();
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: emailTemplate['templateName'] + ' is deleted successfully',
      });
    });
  }
  public cloneEmailTemplate(emailTemplate: any) {
    this.spinnerService.show();
    this.emailTemplatesService.cloneEmailTemplate(emailTemplate).subscribe(() => {
      this.spinnerService.hide();
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Email Template is cloned successfully',
      });
    });
  }

  public openEditForm(formData: any): void {
    this.modalService
      .custom(CustomDialogComponent, {
        title: 'Edit Email Template',
        modalType: 'add-edit-email-template',
        formType: 'Edit',
        formData: formData,
      })
      .pipe(take(1))
      .subscribe((result: any) => {
        if (result) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Email template is updated succesfully.',
          });
        }
      });
  }
}
